import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen} from '@fortawesome/free-solid-svg-icons';

import {Article} from '../Services/ArticleService';
import {AppState} from '../Store';
import Thumbnail from './Thumbnail';
import PostMeta from './PostMeta';
import ArticleLink from './ArticleLink';
import CategoryLink from './CategoryLink';
import markdownPreview from '../Shared/markdownPreview';

interface ArticleProps {
  article: Article;
  vertical: boolean;
  admin: boolean;
  priorityModules: string[];
}

function ArticlePreview({
  article,
  vertical,
  admin,
  priorityModules,
}: ArticleProps) {
  let divClass: string;
  if (vertical) {
    divClass = "single-blog-post";
  } else {
    divClass = "single-blog-post post-style-4 d-flex align-items-center";
  }

  if (!article.published) {
    divClass = `${divClass} unpublished`;
  }

  let mainModule = undefined;
  if (!vertical) {
    for (const category of article.categories) {
      if (priorityModules.includes(category)) {
        mainModule = category;
      }
    }
  }

  return (
    <div className={divClass}>
      <Thumbnail article={article} />
      <div className="post-content">
        <h5>
          <ArticleLink id={article.id}>{article.title}</ArticleLink>
          {admin ? <Link to={`/admin/articles/${article.id}`}> <FontAwesomeIcon icon={faPen} /></Link> : null}
          {!article.published
            ? ' (draft)'
            : null
          }
          {mainModule !== undefined
            ? <CategoryLink className="float-right" category={mainModule} />
            : null
          }
        </h5>
        <p>{markdownPreview(article.body)}</p>
        <PostMeta article={article} footer={false} breadcrumb={false} />
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppState) => ({
  admin: state.auth.admin,
  priorityModules: state.home.priorityModules,
});

export default connect(mapStateToProps)(ArticlePreview);
